if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class ProductDescription extends HTMLElement {
      connectedCallback() {
        const lineLimit = parseInt(this.dataset.lineLimit, 10) || 4;
        const full = this.querySelector('.product__description-full');
        const toggle = this.querySelector('.product__description-toggle');
        if (!full || !toggle) return;

        full.style.setProperty('--line-clamp', lineLimit);
        full.classList.add('product__description--clamped');

        const checkOverflow = () => full.scrollHeight > full.clientHeight + 1;

        const updateToggle = () => {
          if (!checkOverflow()) {
            full.classList.remove('product__description--clamped');
            toggle.hidden = true;
            return;
          }
          toggle.hidden = false;
        };

        requestAnimationFrame(updateToggle);

        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          const showMore = toggle.querySelector('[data-show-more]');
          const showLess = toggle.querySelector('[data-show-less]');

          if (expanded) {
            full.classList.add('product__description--clamped');
            toggle.setAttribute('aria-expanded', 'false');
            if (showMore) showMore.hidden = false;
            if (showLess) showLess.hidden = true;
          } else {
            full.classList.remove('product__description--clamped');
            toggle.setAttribute('aria-expanded', 'true');
            if (showMore) showMore.hidden = true;
            if (showLess) showLess.hidden = false;
          }
        });
      }
    }
  );
}
